<template>
    <div class="m-team">
        <h5 class="title"></h5>

        <div class="view">
            <div class="team-list" v-if="ready">
                <div class="team-item" v-for="(item,index) in list" :key="index">
                    <div class="logo">
                        <div class="circle"></div>
                        <a :href="'//www.m3guo.com/activity/202205/mpl/info/?tid=' + item.teamId" target="_blank" rel="noopener noreferrer"><img :src="item.logo" :alt="item.name"></a>
                    </div>
                    <p class="team-name">{{ item.name }}</p>
                </div>
            </div>

            <loading v-else/>
        </div>
    </div>
</template>

<script>
export default {
    data (){
        return {
            list : [],
            ready : false,
        }
    },
    props :{
        'active' : {
            default : false,
        }
    },
    inject : ['reload'],
    created (){
        // this.render_live();
        // this.render_news();
    },
    watch : {
        active (val){
            if(val && !this.ready){
                this.render();             
            }
        },
    },
    methods : {
        render(){
            let vm = this;
            this.$axios.get(this.$ajax_url_map.team)
            .then(
                res => {
                    this.list = res
                    this.ready = true
                    setTimeout( ()=> {
                        vm.reload()
                    },1000)
                },
                rej => {}
            )            
        },
    },  
}
</script>

<style scoped>

    .m-team{
        margin-top: 130px;
    }

    .title{
        width: 242px;
        height: 37px;
        margin-bottom: 40px;
        background-image: url(~@/assets/images/team/title.png);        
    }

    .m-team .view{
        position: relative;
        min-height: 614px;
    }

    .team-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 70px;
    }

    .team-item{
        width: 181px;
        margin: 0 46px 36px;
        padding-top: 24px;
        box-sizing: border-box;
        /* background-image: url(~@/assets/images/team/bg-team.png);   */
    }

    .team-item .logo{
        position: relative;
        width: 181px;
        height: 172px;
        margin: 0 auto;
    }

    .team-item .logo a{
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
    }

    .logo .circle{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 181px;
        height: 172px;
        margin-left: -90.5px;
        margin-top: -86px;
        background-image: url(~@/assets/images/team/bg-team.png);      
    }

    .team-item:hover .logo .circle{
        animation: logo_rotate 3s infinite;
    }

    .team-item .logo img{
        position: absolute;
        left: 50%;
        top: 50%;
        max-width: 169px;
        transform: translate(-50%,-50%);
    }

    .team-name{
        margin-top: 5px;
        text-align: center;
        font-size: 22px;
        color: #444444;
    }

    @keyframes logo_rotate {
        0%{
            transform: rotate(0);
        }

        100%{
            transform: rotate(360deg);
        }        
    }
</style>


// WEBPACK FOOTER //
// src/components/page/team.vue